// extracted by mini-css-extract-plugin
module.exports = {"teaserFooter":"TeaserFooter_teaserFooter__595EL","timestamp":"TeaserFooter_timestamp__UZfXq","regular":"TeaserFooter_regular__IJ_ZG","premium":"TeaserFooter_premium__lz4Td"};